export const getPreviousMonthName = () => {
  const MONTH_CHOICES = [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December',
  ];
  const now = new Date();
  const prevMonth = new Date(now.getFullYear(), now.getMonth() - 1);
  return MONTH_CHOICES[prevMonth.getMonth()];
};

export const getInitialPayrollFormData = () => ({
  employee: '',
  month: getPreviousMonthName(),
  year: new Date().getFullYear(),
  basic_salary: 0,
  transport_allowance: 0,
  bonus_dues: 0,
  weekends_pay: 0,
  worked_days: 30,
  gross_payable: 0,
  absent_deductions: 0,
  loan_deductions: 0,
  tax_deductions: 0,
  other_deductions: 0,
  late_deductions: 0,
  absent_days: 0,
  leave_days: 0,
  net_payable: 0,
  payment_status: 'Pending',
  payment_mode: 'Bank Transfer',
  payment_currency: 'PKR',
  payment_date: new Date().toISOString().split('T')[0],
});

export const calculateGrossPayable = (data) =>
  parseInt(data.basic_salary || 0, 10) +
  parseInt(data.transport_allowance || 0, 10) +
  parseInt(data.bonus_dues || 0, 10) +
  parseInt(data.weekends_pay || 0, 10);

export const calculateNetPayable = (data) => {
  const gross = calculateGrossPayable(data);
  const deductions =
    parseInt(data.absent_deductions || 0, 10) +
    parseInt(data.loan_deductions || 0, 10) +
    parseInt(data.tax_deductions || 0, 10) +
    parseInt(data.other_deductions || 0, 10) +
    parseInt(data.late_deductions || 0, 10);
  return Math.max(0, gross - deductions);
};

export const getPayrollFormDataFromRecord = (payroll) => ({
  employee: payroll.employee?.id || 0,
  month: payroll.month || 0,
  year: payroll.year || new Date().getFullYear(),
  basic_salary: payroll.basic_salary || 0,
  transport_allowance: payroll.transport_allowance || 0,
  bonus_dues: payroll.bonus_dues || 0,
  weekends_pay: payroll.weekends_pay || 0,
  worked_days: payroll.worked_days || 0,
  gross_payable: payroll.gross_payable || 0,
  absent_deductions: payroll.absent_deductions || 0,
  loan_deductions: payroll.loan_deductions || 0,
  tax_deductions: payroll.tax_deductions || 0,
  other_deductions: payroll.other_deductions || 0,
  late_deductions: payroll.late_deductions || 0,
  absent_days: payroll.absent_days || 0,
  leave_days: payroll.leave_days || 0,
  net_payable: payroll.net_payable || 0,
  payment_status: payroll.payment_status || 'Pending',
  payment_mode: payroll.payment_mode || 'Bank Transfer',
  payment_currency: payroll.payment_currency || 'PKR',
  payment_date: payroll.payment_date || 0,
});

export const formatPayrollDataForSubmission = (formData) => ({
  employee: formData.employee,
  month: formData.month,
  year: formData.year,
  basic_salary: formData.basic_salary !== '' && formData.basic_salary != null ? parseInt(formData.basic_salary, 10) : null,
  transport_allowance: formData.transport_allowance !== '' && formData.transport_allowance != null ? parseInt(formData.transport_allowance, 10) : 0,
  bonus_dues: formData.bonus_dues !== '' && formData.bonus_dues != null ? parseInt(formData.bonus_dues, 10) : 0,
  weekends_pay: formData.weekends_pay !== '' && formData.weekends_pay != null ? parseInt(formData.weekends_pay, 10) : 0,
  worked_days: formData.worked_days !== '' && formData.worked_days != null ? parseFloat(formData.worked_days) : null,
  gross_payable: formData.gross_payable !== '' && formData.gross_payable != null ? parseInt(formData.gross_payable, 10) : null,
  absent_deductions: formData.absent_deductions !== '' && formData.absent_deductions != null ? parseInt(formData.absent_deductions, 10) : 0,
  loan_deductions: formData.loan_deductions !== '' && formData.loan_deductions != null ? parseInt(formData.loan_deductions, 10) : 0,
  tax_deductions: formData.tax_deductions !== '' && formData.tax_deductions != null ? parseInt(formData.tax_deductions, 10) : 0,
  other_deductions: formData.other_deductions !== '' && formData.other_deductions != null ? parseInt(formData.other_deductions, 10) : 0,
  late_deductions: formData.late_deductions !== '' && formData.late_deductions != null ? parseInt(formData.late_deductions, 10) : 0,
  absent_days: formData.absent_days !== '' && formData.absent_days != null ? parseFloat(formData.absent_days) : 0,
  leave_days: formData.leave_days !== '' && formData.leave_days != null ? parseFloat(formData.leave_days) : 0,
  net_payable: formData.net_payable !== '' && formData.net_payable != null ? parseInt(formData.net_payable, 10) : null,
  payment_status: formData.payment_status,
  payment_mode: formData.payment_mode,
  payment_currency: formData.payment_currency,
  payment_date: formData.payment_date || null,
});

export const MONTH_CHOICES = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December',
];

export const YEAR_CHOICES = Array.from({ length: 9 }, (_, i) => 2022 + i);

export const PAYMENT_STATUS_CHOICES = [
  { value: 'Pending', label: 'Pending' },
  { value: 'Approved', label: 'Approved' },
  { value: 'Rejected', label: 'Rejected' },
  { value: 'On Hold', label: 'On Hold' },
  { value: 'Paid', label: 'Paid' },
];

export const PAYMENT_MODE_CHOICES = [
  { value: 'Bank Transfer', label: 'Bank Transfer' },
  { value: 'Bank Deposit', label: 'Bank Deposit' },
  { value: 'Cash', label: 'Cash' },
  { value: 'Cheque', label: 'Cheque' },
];

export const PAYMENT_CURRENCY_CHOICES = ['USD', 'PKR', 'AED', 'EUR', 'GBP'];
